export default __webpack_public_path__ + "24080ac87e0054af8c7e1733907ed7af.svg";